export const FETCH_TIMESHEET = "FETCH_TIMESHEET";
export const FETCH_ALL_TIMESHEETS = "FETCH_ALL_TIMESHEETS";
export const ADD_TIMESHEET = "ADD_TIMESHEET";
export const APPROVE_TIMESHEET = "APPROVE_TIMESHEET";
export const UPDATE_TIMESHEET = "UPDATE_TIMESHEET";
export const REMOVE_ATTACHMENT = "REMOVE_ATTACHMENT";
export const FETCH_ATTACHMENTS = "FETCH_ATTACHMENTS";
export const UPLOAD_TIMESHEET = "UPLOAD_TIMESHEET";
export const DEFAULTERS_REPORTS = "DEFAULTERS_REPORTS";
export const SUMMARY_REPORTS = "SUMMARY_REPORTS";
export const TASK_REPORTS= "TASK_REPORTS";
export const SUMMARY_BY_DAY_REPORTS = "SUMMARY_BY_DAY_REPORTS";

export const GET_ALL_PROJECTS = "GET_ALL_PROJECTS";
export const GET_ACTIVE_PROJECT = "GET_ACTIVE_PROJECT";
export const DELETE_PROJECT = "DELETE_PROJECT";
export const GET_PROJECT_LIST = "GET_PROJECT_LIST";

export const GET_ALL_APP_USERS = "GET_ALL_APP_USERS";
export const GET_ALL_EXT_USERS = "GET_ALL_EXT_USERS";
export const GET_APP_USER = "GET_APP_USER";
export const GET_EXT_USER = "GET_EXT_USER";
export const GET_JOB_TITLES = "GET_JOB_TITLES";
export const GET_MANAGERS_USERS = "GET_MANAGERS_USERS";

export const VERIFY_USER = "VERIFY_USER";
export const SET_USER = "SET_USER";
export const FETCH_ALL_USERS = "GET_USERS";
export const SET_AUTH_INFO = "SET_AUTH_INFO";

export const GET_VACATION_HOUR_LIST = "GET_VACATION_HOUR_LIST";
export const GET_CURRENT_VACATION_HOUR_LIST = "GET_CURRENT_VACATION_HOUR_LIST";
export const GET_BILLING_LIST = "GET_BILLING_LIST";
export const GET_BILLING_REPORT_DATA = "GET_BILLING_REPORT_DATA";

export const GET_VENDORS = "GET_VENDORS";
export const GET_VENDOR_DETAILS = "GET_VENDOR_DETAILS";

export const GET_REQUESTS = "GET_ALL_REQUESTS";
export const GET_EMPLOYEE_REQUESTS = "GET_EMPLOYEE_REQUESTS";
export const GET_REQUEST = "GET_REQUEST";
export const CREATE_REQUEST = "CREATE_REQUEST";
export const UPDATE_REQUEST = "UPDATE_REQUEST";
export const DELETE_REQUEST = "DELETE_REQUEST";
